import jQuery from 'jquery';

Mobi2Go.UI.View({
    name: 'order_closing_soon_warning',
    model: Mobi2Go.Order,
    el: '[data-view="order-minutes-to-closing"]',
    template: jQuery('[data-template="order-minutes-to-closing"]').html(),
    model_listeners: {
        updateMinutesToClosing: 'render',
    },
    render(minutes_to_closing) {
        const html = this.template({
            minutes_to_closing,
            Order: Mobi2Go.Order,
        });
        this.$el.html(html);
    },
});
